// extracted by css-extract-rspack-plugin
export default {"wrapper":"src-components-UserPicker-module__wrapper-sjtnkB","input":"src-components-UserPicker-module__input-Rglf_A","loadingHint":"src-components-UserPicker-module__loadingHint-oHryvk","dropdown":"src-components-UserPicker-module__dropdown-hK7iVt","dropdownItem":"src-components-UserPicker-module__dropdownItem-RCFkz1","noResults":"src-components-UserPicker-module__noResults-E3x8Jx"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"wrapper\":\"src-components-UserPicker-module__wrapper-sjtnkB\",\"input\":\"src-components-UserPicker-module__input-Rglf_A\",\"loadingHint\":\"src-components-UserPicker-module__loadingHint-oHryvk\",\"dropdown\":\"src-components-UserPicker-module__dropdown-hK7iVt\",\"dropdownItem\":\"src-components-UserPicker-module__dropdownItem-RCFkz1\",\"noResults\":\"src-components-UserPicker-module__noResults-E3x8Jx\"}";
        // 1793732345519
        var cssReload = require("../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  